import React from "react";
import { BOOKING_COUNTING_STATUSES } from "../constants";
import LearnMore from "../../../../components/learnMore/learnMore";

import styles from "../funnelChart.module.css";

export function LaserLearnMore({ title, showFutureAppointment }) {
  return (
    <LearnMore
      title={title}
      content={
        <>
          <p>
            The iKizmet LASER module was created to see where your leads are currently in your sales
            funnel. This report will NOT match what you will see in the referrals report in
            ClubReady. The date selector will only capture the “Start From” data. All the other data
            is not confined to the date selector.
          </p>
          <h3>Start From </h3>
          <p>
            <b>Start From Lead (Profile Creation):</b>
            <br />
            Lead will count any new profile based on the date of creation.
            <br />
            Appointment counts how many of those leads have scheduled their first booking.
            <br />
            Show counts the number of those leads that scheduled their first booking, who completed
            a visit.
            <br />
            Enrollment counts how many of the leads that book and showed for their first class or
            appointment that make a qualifying purchase.
          </p>
          <p>
            <b>Start From Appointment (First Booking):</b>
            <br />
            Appointment counts how many first bookings regardless of when the profile was created.
            <br />
            Show counts the number of first bookings that completed their first visit. Enrollment
            counts how many of the clients with first bookings and a completed class or appointment
            that make a qualifying purchase.
          </p>
          <p>
            <b>Start From Show (First Visit):</b>
            <br />
            Show - first completed visit by a client. We will not look at when the profiles was
            created nor when the first booking was made. Only the first completed visit.
            <br />
            Enrollment - counts how many of the clients with first completed visit or appointment
            that make a qualifying purchase.
          </p>
          <p>
            <b>Start From Intro Offer (Introductory Offer Purchase):</b>
            <br />
            Intro Offer will count the number of purchases of a sales package/package that is tagged
            as an Introductory Offer. <br />
            First Visit will count the number of those intro offers that completed their first
            visits.
            <br />
            Converted will counts how many of the clients that purchased an Intro Offer, completed a
            first visit than purchased a qualifying sales package/package.
          </p>
          <h3>Network Averages</h3>
          <p>
            If your brand/organization has this feature turned on, you will be able to compare your
            stats to other store in your organization. The smaller number in the rounded square is
            average depending on the filter you selected.
          </p>
          <p>
            The filters can have available are the ‘network’, all the stores that are loaded in
            iKizmet for your brand. Or you can choose to select your division’, or ‘district’ that
            your store is connected to in ClubReady. You can also select your iKizmet Region.
          </p>
          {showFutureAppointment ? (
            <>
              <b>Future Bookings Toggle</b>
              <p>
                When toggled on [<span style={{ color: "#8fc447", fontWeight: "bold" }}>green</span>
                ], the laser chart will look for future appointments for the leads shown in the
                chart. For example, the calendar end date is set from January 1st to January 31st
                and today is January 31st. When toggled on, it will find appointments set in
                February, in the future. If the leads have appointments booked in the future this
                will affect metrics as an increase to Lead to Appointment Percentage, a decrease to
                Appointment to Show Percentage and an increase to the Appointment total metric.
              </p>
            </>
          ) : (
            ""
          )}
          <p>
            <b>Include Loose Conversions Toggle</b>
            <br />
            Off [<span style={{ fontWeight: "bold" }}>white</span>] - A client will not be counted
            as enrolled/converted if they do not have an appointment and show when the funnel is
            started from the lead. Nor will the client be counted as converted if they do not have a
            first visit when the funnel is starting from the Intro Offer.
            <br />
            On [<span style={{ color: "#8fc447", fontWeight: "bold" }}>green</span>] - A client can
            be counted as enrolled/converted even if they have not completed the other steps in the
            funnel; Appointment, Show or First Visit.
          </p>
          <p>
            <b>Exclude Enrolled Bookings Toggle</b>
            <br />
            This toggle will exclude first bookings (appointment and visits/shows) when the prospect
            or lead has already enrolled/converted. If the first booking date is later than
            enrollment date, the booking will not count in the Appointment and the Show section.
          </p>
          <p>
            <b>Avg. Number of Days to Appointment:</b> The average number of days from a lead
            (profile creation date) to making an appointment (first booking).
          </p>
          <p>
            <b>Avg. Number of Days to Conversion:</b> The average number of days from a lead
            (profile creation date) to conversion (first qualifying purchase).
          </p>
          <p>
            The <b>Lead</b> metric counts any new person added to a location based on the profile
            creation date. Leads can be added the same day as their first visit but can also be
            added beforehand from a marketing effort, referral, website, or other online lead
            capture.
          </p>
          <p>
            The <b>Appointment</b> metric counts how many leads have scheduled their first
            appointment or class visit. The difference between the appointments and leads totals is
            when a lead fails to schedule their first visit.
          </p>
          <table className={styles.tableLearn}>
            <thead>
              <tr>
                <th />
                <th>Appointment Status</th>
                <th>Appointment</th>
                <th>Show</th>
              </tr>
            </thead>
            <tbody>
              {BOOKING_COUNTING_STATUSES.map((value, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td className={styles.tableLearnRows}>
                    <b>{value.status}</b>
                    {value.description}
                  </td>
                  <td className={styles.tableLearnRows}>{value.appointment}</td>
                  <td className={styles.tableLearnRows}>{value.show}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>
            The <b>Show</b> metric counts how many prospects complete their visit. The difference
            between the appointment and show metrics are leads that “no show” their appointment and
            never have their first visit. Only completed bookings will count in the Show metric.
          </p>
          <p>
            The <b>Enrollment</b> metric counts how many of the clients that show for their first
            visit have a qualifying purchase. If desired, some purchases like free visits can be
            excluded as a qualifying purchase from the sales package mapping page by clicking the
            “using for retention” button.
            <br />
            <b>**Note: </b>
            <i>
              The client must show to be counted as enrolled unless the Include Loose Conversions
              toggle is turned ON.
            </i>
            <br />
          </p>
          <p>
            Hovering over the enrollment part of the funnel will display clickable options that
            break down enrollment purchases by Membership, Intro Offers, and Packages.
            <br />A package that is not a membership that is tagged as using for retention, will
            show in the Packages section. For a package to be considered an Intro Offer, it will
            need to be tagged in the package settings in iKizmet. Both Intro Offers and Packages are
            tagged set at the organization level and my not be turned on for your brand. If a client
            purchases multiple items, then the order of priority is membership, intro offers, then
            other packages.
          </p>
          <h3>Referral Table</h3>
          <p>
            The table will allow you to see how your referrals are preforming by display the data
            from the above chart but broken down by your categories or sources depending on the
            toggle. We will also show the total amount of revenue each source or category has
            brought into your business. The Revenue per Referral is the amount of revenue divided by
            the total number of leads.
          </p>
          <p>
            Referral Category toggle
            <br />
            On [<span style={{ color: "#8fc447", fontWeight: "bold" }}>green</span>] - The table
            will show the category based on brand mapping. This is the default setting.
            <br />
            Off [<span style={{ fontWeight: "bold" }}>white</span>] – Each referral source will be
            shown in the table. Usually there will be more lines when this setting is turned off.
          </p>
        </>
      }
    />
  );
}
